import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ModalButtons from "../ModalButtons/ModalButtons";
import CreditCard from "./CreditCard";

export default class RemoveCard extends React.Component{

  constructor(props){
    super(props);
    this.state={
      loading: false,
    };

    this.removeCards = this.removeCards.bind(this);
  }

  render(){
    return(
      <div className="CardBuilder">
        <LoadingSpinner show={this.state.loading} />
        <ModalButtons loading={this.state.loading} buttons={this.buttons()} />
        <div className="cards">
        {this.renderCards()}
        </div>
      </div>
    );
  }

  renderCards(){
    return this.props.cards.map((card) =>{
      return <CreditCard key={card.id}
        card={card}
      />
    });
  }

  buttons() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ],
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary', 'modal-footer', 'btn-primary', 'submit-buttons'],
        onClick: (e) => {
          this.removeCards();
        }
      },
    ];
    return buttons
  }

  removeCards(){
    this.setState({ loading: true })
    $.ajax({
      type: 'POST',
      url: '/admin/cards/remove-delete',
      data: {
        card_ids: this.props.cards.map(card => card.id),
      },
    }).done((data) => {
      if (data.success) {
        this.setState({ loading: false })
        window.parent.$(window.parent).trigger("folioItemSavedSuccessfully")
        parent.refresh_data()
        parent.hide_modal()
      } else if (data.errors) {
        this.setState({
          loading: false,
          errors: data.errors,
        });
      };
    });
  }

}
